<template>
  <div class="ScreenAdapter" :style="style">
    <slot />
  </div>
</template>
<script>
export default {
  name: "",
  //参数注入
  props: {
    width: {
      type: String,
      default: "1920",
    },
    height: {
      type: String,
      default: "1080",
    },
  },
  data() {
    return {
      style: {
        width: this.width + "px",
        height: this.height + "px",
        transform: "scale(1)",
      },
    };
  },
  mounted() {
    this.setScale();
    let that = this;
    // window.onresize = this.Debounce(this.setScale, 1000);
    window.addEventListener("resize", function () {
      // that.Debounce(that.setScale, 1000);
      that.setScale();
    });
  },
  methods: {
    Debounce: (fn, t) => {
      const delay = t || 500;
      let timer;
      return function () {
        const args = arguments;
        if (timer) {
          clearTimeout(timer);
        }
        const context = this;
        timer = setTimeout(() => {
          timer = null;
          fn.apply(context, args);
        }, delay);
      };
    },
    // 获取放大缩小比例
    getScale() {
      const w = document.documentElement.clientWidth / this.width;
      const h = document.documentElement.clientHeight / this.height;
      // return w < h ? w : h;
      // const w = window.innerWidth / this.width;
      // const h = window.innerHeight / this.height;
      // return [w, h];
      return document.body.clientWidth / 1920;
    },
    // 设置比例
    setScale() {
      // this.style.transform =
      //   "scale(" +
      //   this.getScale()[0] +
      //   "," +
      //   this.getScale()[1] +
      //   ") translate(-50%, -50%)";
      console.log("窗口变化");
      this.style.transform = "scale(" + this.getScale() + ") ";
    },
  },
};
</script>
<style lang="scss" scoped>
.ScreenAdapter {
  width: 100%;
  height: 100%;
  transform-origin: 0 0;
  transform-origin: left top;
  // position: absolute;
  // left: 50%;
  // top: 50%;
  transition: 0.3s;
  overflow: hidden;
}
</style>
